import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Badge, Card, CardContent, PageLoading } from "@dosa/ui";
import { listUsers } from "../../lib/api-client";

export function AdminUsersPage() {
  const { t } = useTranslation();
  const { data: users, isLoading } = useQuery({ queryKey: ["users"], queryFn: listUsers });

  if (isLoading) return <PageLoading />;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.users.title")}</h1>
      <Card>
        <CardContent className="p-0">
          <ul className="divide-y divide-charcoal-100">
            {users?.map((u) => (
              <li key={u.id} className="flex items-center justify-between px-5 py-4">
                <div>
                  <p className="font-medium text-charcoal-800">{u.email}</p>
                  <p className="text-sm text-charcoal-400">{t(`roles.${u.role.toLowerCase()}`)}</p>
                </div>
                <Badge variant={u.status === "ACTIVE" ? "success" : "neutral"}>{u.status}</Badge>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
